import React, { Dispatch, SetStateAction } from "react"
import { CustomReasonCode, Maybe, OrderCancellation } from "lib/types/generated/graphql-types"
import { useQuery } from "@apollo/client"
import { ButtonWrapper, Container } from "../../Updates/Shared.styled"
import GET_CANCELLATION from "../../../../graphql/queries/order/GetCancellation"
import AddedReason from "../Reason/AddedReason"
import ALL_REASON_CODES from "../../../../graphql/queries/settings/reasonCodes/AllReasonCodes"
import PrimaryButton from "../../../Ui/Buttons/PrimaryButton"

type Props = {
  ongoingCancellation: OrderCancellation
  setShowCancelPopup: Dispatch<SetStateAction<boolean>>
}

const OngoingCancellation = ({ ongoingCancellation, setShowCancelPopup }: Props) => {
  const { data, loading } = useQuery(GET_CANCELLATION, {
    variables: { cancellationId: ongoingCancellation?.id }
  })

  const cancellation = data?.Order?.cancellation as OrderCancellation

  const { data: reasonData } = useQuery(ALL_REASON_CODES)
  const customReasons = reasonData?.Order?.customReasonCodes?.codes

  const getCustomCode = (code: Maybe<string> | undefined) =>
    customReasons?.find((customCode: CustomReasonCode) => customCode.code === code)

  return (
    <Container className={loading ? "blur" : ""}>
      <h4>Ongoing cancellation #{cancellation?.id}</h4>
      <AddedReason reason={cancellation?.reason} getCustomCode={getCustomCode} disableDelete={true}/>
      <ButtonWrapper >
        <PrimaryButton handleClick={() => setShowCancelPopup(true)}>Handle cancellation</PrimaryButton>
      </ButtonWrapper>
    </Container>
  )
}

export default OngoingCancellation
